import React from "react";
import ReactDOM from "react-dom/client";
import { OcEnvironmentBanner } from "./components/shared/OcEnvironmentBanner";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { OcApp } from "./OcApp";
import { OcToastProvider } from "./components/shared/OcToast";
import { OcErrorBoundary } from "./components/shared/OcErrorBoundary";
import "./styles/oc-globals.css";
import { ocRegisterServiceWorker } from "./lib/oc-pwa";
import { ocInstallStaleBuildRecovery } from "./lib/oc-stale-build";

ocRegisterServiceWorker();
ocInstallStaleBuildRecovery();

const ocQueryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 2 },
  },
});

ReactDOM.createRoot(document.getElementById("oc-root")!).render(
  <React.StrictMode>
    <OcEnvironmentBanner />
    <OcErrorBoundary>
      <QueryClientProvider client={ocQueryClient}>
        <BrowserRouter>
          <OcToastProvider>
            <OcApp />
          </OcToastProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </OcErrorBoundary>
  </React.StrictMode>
);
